import React from 'react';

export default class QuotationProductDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state={
        }
    }

    showTransportRows(){
        if(this.props.cotacao.isClientPayingFreight()){
            return(
                <tr>
                    <td colSpan="5" className="blankRow">
                    </td>
                    <td className="subtotalLabel">Transporte: </td>
                    <td className="subtotalValue" colSpan="2">
                        <div id="moneyValue">
                        R$ {this.props.cotacao.getValorTransporte()}
                        </div>
                    </td>
                </tr>
            )}
            else{
                return (
                    <tr>
                        <td colSpan="5" className="blankRow">
                        </td>
                        <td className="subtotalValue" colSpan="3">
                            <div id="moneyValue">
                                FRETE INCLUSO
                            </div>
                        </td>
                    </tr>
                )
            }
        }


    showDescontoRows(){
        if(this.props.cotacao.getDesconto()>0){
            return(
                <tr>
                    <td colSpan="5" className="blankRow">
                    </td>
                    <td className="subtotalLabel">Desconto: </td>
                    <td className="subtotalValue" colSpan="2">
                        <div id="moneyValue">
                        R$ {this.props.cotacao.getDesconto()}
                        </div>
                    </td>
                </tr>
            )}
        else{
                return ""
            }

    }

    //remember to sync localStorage with server responses

    render() {
        return (
            <div className="quotationProductDetailsOutter">
                <div className="quoteItemContainer">
                    <table id="items">
                    <tbody>
                    <tr>
                        <th>ITEM</th>
                        <th>Descrição</th>
                        <th>UN</th>
                        <th>Peso/un (kg)</th>
                        <th>R$/un</th>
                        <th>Qtd</th>
                        <th>Peso (kg)</th>
                        <th>TOTAL (R$)</th>

                    </tr>
                    {this.props.cotacao.getItens().map(function(item, i){
                        return(
                            <tr key={i}>
                                <td>{i+1}</td>
                                <td>{item.getProduto().getNameAndDescription()}</td>
                                <td className="unity">{item.getProduto().getUnity()}</td>
                                <td>{item.getProduto().getKgPerUnit()}</td>
                                <td>{item.getProduto().getPrice()}</td>
                                <td>{item.getQuantity()}</td>
                                <td className="total-value">{item.getWeight()}</td>
                                <td className="total-value">{item.getSubtotal()}</td>
                            </tr>
                        )
                    },this)}

                    <tr>
                        <td colspan="2" className="blankColumn">
                            <div className="bankData">
                                {this.showBank()}
                            </div>
                        </td>
                        <td colspan="3" className="blankColumn">
                            {this.showShipping()}

                        </td>
                        <td colspan="3" className="blankColumn">
                            <div>
                                <table>
                                    <tbody>
                                    <tr>
                                        <td className="blankRow" colSpan="5">
                                        </td>
                                        <td className="subtotalLabel">Subtotal: </td>
                                        <td className="subtotalValue" colSpan="2">
                                            <div id="moneyValue">
                                                R$ {this.props.cotacao.getSubtotalDosProdutos()}
                                            </div>
                                        </td>
                                    </tr>
                                    {this.showTransportRows()}
                                    {this.showDescontoRows()}
                                    <tr>
                                        <td className="blankRow" colSpan="5">

                                        </td>
                                        <td className="subtotalLabel">Total: </td>
                                        <td className="subtotalValue" colSpan="2">
                                            <div id="moneyValue">
                                                R$ {this.props.cotacao.getTotal()}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="blankRow" colSpan="5"/>
                                        <td className="subtotalLabel">Valor Pago: </td>
                                        <td className="subtotalValue" colSpan="2">
                                            <div id="moneyValue">
                                                R$ {this.props.invoice.getAmountPaid()}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="blankRow" colSpan="5"/>
                                        <td className="totalLabel">Saldo devedor: </td>
                                        <td className="totalValue" colSpan="2">
                                            <div id="moneyValue">
                                                R$ {this.props.invoice.getBalance()}
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </td>
                    </tr>


                        </tbody>
                    </table>



                </div>

            </div>
        )
    }

    showShipping(){
        if(this.props.cotacao.hasShippingData()){
            return (
                <div className="shippingDetails">
                    <div className="shippedData">
                        Hora do Envio: {this.props.cotacao.getDateAndTimeShipped()}
                    </div>
                    <div className="freight-company-name">
                        {this.props.freightCompany.getName()}
                    </div>
                    <div className="tracking-number">
                        {this.props.cotacao.getTrackingNumber()}
                    </div>
                </div>
            )
        }

    }

    showNotes(){
        if(this.props.cotacao){
            if(this.props.cotacao.note){
                return(
                    <div>
                        {this.props.cotacao.note}
                    </div>
                )
            }
        }
    }

    showBank(){
        if(this.props.bank){
            let id=null;
            if(this.props.bank.type==='business'){
                id="CNPJ: "+this.props.bank.id
            }
            else{
                id="CPF: "+this.props.bank.id
            }
            return(
                <div id="bankData">
                    <div>Conta para depósito:</div>
                    <div id="accountHolder">{this.props.bank.accountHolder}</div>
                    <div id="accountHolderId">{id}</div>
                    <div id="bankName">Banco: {this.props.bank.bankName}</div>
                    <div id="branch">Agência: {this.props.bank.branch}</div>
                    <div id="accountNumber">Número: {this.props.bank.accountNumber}</div>
                </div>
            )
        }
    }
}